import { Link } from "react-router-dom";
import { Container, Section, PageHero, GOOGLE_REVIEW_URL, CtaBanner, Stars, TrustStrip, Star } from "../components/common";
import { useSeo, breadcrumbLd } from "../lib/seo";

export default function Reviews() {
 useSeo({
 title: "Customer Reviews | RPM Auto Repair Riverside, 4.4 Stars",
 description: "Read reviews from RPM Auto Repair customers in Riverside, CA. 4.4-star rated on Google for honest service, fair pricing and quality workmanship since 1995.",
 path: "/reviews",
 jsonLd: [
 breadcrumbLd([{ name: "Home", path: "/" }, { name: "Reviews", path: "/reviews" }]),
 { "@context": "https://schema.org", "@type": "AutoRepair", name: "RPM Auto Repair",
 aggregateRating: { "@type": "AggregateRating", ratingValue: "4.4", reviewCount: "112" } },
 ],
 });
 return (
 <>
 <PageHero eyebrow="What Our Customers Say" title="Reviews From Real Neighbors"
 subtitle="We've earned a 4.4-star reputation the honest way, one trusted repair at a time."
 image="https://images.pexels.com/photos/8985457/pexels-photo-8985457.jpeg?auto=compress&cs=tinysrgb&w=1400"
 crumbs={[{ name: "Home", path: "/" }, { name: "Reviews", path: "/reviews" }]} />
 <div className="border-b border-white/10 bg-steel/60">
 <Container className="flex flex-col items-center gap-3 py-10 text-center">
 <div className="font-display text-6xl text-white">4.4</div>
 <Stars value={4.4} size={24} />
 <p className="text-muted-foreground">Based on 112+ verified Google reviews</p>
 <Link to="/review" data-testid="leave-review-cta" className="mt-4 flex items-center gap-2 rounded-md bg-primary px-6 py-3 font-semibold tracking-wide text-white transition-colors hover:bg-racing-dark">
 <Star size={16} className="fill-white" /> Leave Us a Review
 </Link>
 </Container>
 </div>
 <Section>
 <Container className="mx-auto max-w-3xl text-center">
 <h2 className="font-display text-3xl font-600 text-white sm:text-4xl">Read Our Reviews On Google</h2>
 <p className="mx-auto mt-4 max-w-2xl text-muted-foreground">
 Every review on our profile comes straight from a real RPM Auto Repair customer. Read what your Riverside
 neighbors have to say, then see for yourself why drivers have trusted us since 1995.
 </p>
 <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
 <a href={GOOGLE_REVIEW_URL} target="_blank" rel="noopener noreferrer" data-testid="read-google-reviews-btn"
 className="flex items-center gap-2 rounded-md border border-white/15 bg-steel px-6 py-3 font-semibold tracking-wide text-white transition-colors hover:border-primary hover:text-primary">
 Read Reviews on Google
 </a>
 <Link to="/review" data-testid="reviews-leave-review-cta"
 className="flex items-center gap-2 rounded-md bg-primary px-6 py-3 font-semibold tracking-wide text-white transition-colors hover:bg-racing-dark">
 <Star size={16} className="fill-white" /> Leave Us a Review
 </Link>
 </div>
 </Container>
 </Section>
 <TrustStrip />
 <CtaBanner title="Join Thousands of Happy Drivers" />
 </>
 );
}
